// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2wLKJ","emails":"CreateEditClinics_emails__2xYad","emailTagLabel":"CreateEditClinics_emailTagLabel__XKDm2"};